import { IDataLayer, LayerTypeId, LayerViewModel, LmNode } from "./omnia"

import m = omnia.models

export const MinimumZoneArea = omnia.map.MinimumZoneArea

export import getPolygons = omnia.map.getPolygons
export import getLargestPolygon = omnia.map.getLargestPolygon

export import cleanupFeatures = omnia.map.cleanupFeatures
export import cleanupFeature = omnia.map.cleanupFeature
export import cleanupPolygon = omnia.map.cleanupPolygon
export import cleanupLayer = omnia.map.cleanupLayer

export function canCreateLayer(node: LmNode) {

    if (node && (node.field || (node.class == "holding"))) {

        return (node.layerType?.TypeId === LayerTypeId.GenericPlan)
            ? node.field.croppings.some(c => c.currentYear && c.authorized)
            : true

    }


}

export function canEditLayer(lvm: LayerViewModel): boolean {

    if (!lvm) {
        return false
    }

    switch (lvm.typeId) {

        // 221206: specific override for prescriptions
        // Should probably reconsider completely, and provide the information directly at type level?
        case LayerTypeId.PrescriptionPlan:
            return true

        case LayerTypeId.GenericPlan:
            return lvm.cropping?.authorized ?? true

        default:
            return lvm.type?.Standalone && (!lvm.datalayer.Calculated) && (!lvm.datalayer.Satellite)

    }

}

export function canDeleteLayer(layer: IDataLayer): boolean {

    if (!layer) {
        return false
    }

    switch (layer.TypeId) {

        case LayerTypeId.PrescriptionPlan:
        case LayerTypeId.Picture:
            return false

        default:
            return true

    }

}

export function canChangeLayerCropping(layer: IDataLayer): boolean {

    const type = layer?.TypeId

    if (type) {

        switch (type) {
            case LayerTypeId.PrescriptionPlan:
                return false
            default:
                return true
        }

    }

}
